import React from 'react';

export function LegacyCloseOutlinedIcon() {
  return (
    <svg
      className="rounded-full shadow-lg"
      fill="none"
      height="36"
      viewBox="0 0 36 36"
      width="36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" fill="#6A73B5" r="18" />
      <path
        d="M14 14L22 22"
        stroke="#E2E4F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M22 14L14 22"
        stroke="#E2E4F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function LegacyCloseIcon(
  props: React.ReactComponentElement<'svg'>['props']
) {
  return (
    <svg
      className="notification-toast__close-icon"
      height="329pt"
      viewBox="0 0 329.269 329"
      width="329pt"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M194.8 164.77L323.013 36.555c8.343-8.34 8.343-21.825 0-30.164-8.34-8.34-21.825-8.34-30.164 0L164.633 134.605 36.422 6.391c-8.344-8.34-21.824-8.34-30.164 0-8.344 8.34-8.344 21.824 0 30.164l128.21 128.215L6.259 292.984c-8.344 8.34-8.344 21.825 0 30.164a21.266 21.266 0 0015.082 6.25c5.46 0 10.922-2.09 15.082-6.25l128.21-128.214 128.216 128.214a21.273 21.273 0 0015.082 6.25c5.46 0 10.922-2.09 15.082-6.25 8.343-8.34 8.343-21.824 0-30.164zm0 0"
        fill="#a7abc9"
      />
    </svg>
  );
}
